export const CLIENT_REFERENCE_ACCEPT = "image/jpeg,image/png,image/webp";
export const CLIENT_REFERENCE_MAX_BYTES = 15 * 1024 * 1024;

const MIME_TYPES = new Set(["image/jpeg", "image/jpg", "image/png", "image/webp"]);
const EXTENSIONS = new Set(["jpg", "jpeg", "png", "webp"]);

export function validateClientReferenceFile(file) {
  const type = String(file?.type || "").toLowerCase();
  const extension = String(file?.name || "").toLowerCase().split(".").pop();
  if (!(MIME_TYPES.has(type) || EXTENSIONS.has(extension))) {
    return "Формат не поддерживается. Разрешены JPG, PNG или WEBP.";
  }
  if ((file?.size || 0) > CLIENT_REFERENCE_MAX_BYTES) {
    return "Файл слишком большой. Максимум 15 МБ.";
  }
  return null;
}

export function appendClientReferenceIds(current, uploaded) {
  const seen = new Set(current || []);
  const additions = [];
  for (const id of uploaded || []) {
    if (id && !seen.has(id)) {
      seen.add(id);
      additions.push(id);
    }
  }
  return [...(current || []), ...additions];
}

export function removeClientReferenceId(current, mediaId) {
  return (current || []).filter((id) => id !== mediaId);
}
